<!----
    Author: hjlee
    Description:
        메모 컨트롤
---->
<template>
  <div :class="['memo-control', 'memo-type-' + type, floating?'floating-memo-control':'']">
    <div class="memo-summary clickable" @click="toggleCollapse()">
      <span v-if="totalEmergencySize" class="emergency-memo"><i class="fa fa-heartbeat" /> {{ totalEmergencySize }}</span>
      <span class="normal-memo"><i class="fa fa-file-o" /> {{ totalSize }}</span>
      <div v-if="!floating" class="collapse-button">
        <i v-if="collapsed" class="fa fa-angle-down" />
        <i v-else class="fa fa-angle-up" />
      </div>
    </div>
    <div v-if="!collapsed" :class="{'memo-list-container': true, 'floating': floating}">
      <div>
        <div class="close-button-area" @click="toggleCollapse()">
          x
        </div>
        <div class="memo-container-title">
          {{ $t('item.nm.memo') }}
        </div>
        <div class="memo-include-ended-checkbox-area">
          <input :id="tableName + '-' + columnName + '-' + tableKey + '-include-ended'" v-model="includeEndedMemo" type="checkbox" @change="clickIncludeEndedMemo($event)"> <label :for="tableName + '-' + columnName + '-' + tableKey + '-include-ended'">{{ $t('memo.checkbox.include_ended') }}</label>
        </div>
        <div class="memo-list">
          <div v-if="(!memos || memos.length === 0) && (!emergencyMemos || emergencyMemos.length === 0)" class="no-memo" v-html="$t('memo.text.no_memo')" />
          <div v-else>
            <memo
              v-for="(memo, memoIndex) in emergencyMemos"
              :key="'emergency-memo-' + tableKey + '-' + memo.id"
              :index="memoIndex"
              :readonly="readonly"
              :disabled="disabled"
              :table-key="tableKey"
              :use-comment="options.useComment"
              :use-charger="options.useCharger"
              :use-title="options.useTitle"
              :use-priority="options.usePriority"
              :use-attachment="options.useAttachment"
              :for-table="options.forTable"
              :type="options.type"
              :sttus-code-group="options.sttusCodeGroup"
              :time="memo.timePosition"
              :data="memo"
              :editor-options="editorOptions"
              :priority-options="priorityOptionsWithoutEmptyValue"
              :status-options="statusOptionsWithoutEmptyValue"
              @deleted="onDeleted"
              @updated="onUpdated"
            />
            <memo
              v-for="(memo, memoIndex) in memos"
              :key="'memo-' + tableKey + '-' + memo.id"
              :index="memoIndex"
              :readonly="readonly"
              :disabled="disabled"
              :table-key="tableKey"
              :use-comment="options.useComment"
              :use-charger="options.useCharger"
              :use-title="options.useTitle"
              :use-priority="options.usePriority"
              :use-attachment="options.useAttachment"
              :for-table="options.forTable"
              :type="options.type"
              :sttus-code-group="options.sttusCodeGroup"
              :time="memo.timePosition"
              :data="memo"
              :priority-options="priorityOptionsWithoutEmptyValue"
              :editor-options="editorOptions"
              :status-options="statusOptionsWithoutEmptyValue"
              @deleted="onDeleted"
              @updated="onUpdated"
            />
            <div v-if="isBusy">
              <img src="~assets/img/ajax-loader-white-bg.gif" alt="Loading...">
            </div>
            <button v-if="loadedSize < totalSize" class="form-control btn btn-light" @click="load(true)">
              {{ $t('common.button.view_more') }}
            </button>
          </div>
        </div>
        <div v-if="!disabled && !readonly" class="insert-memo-control">
          <div class="insert-memo-control-title clickable" @click="toggleCollapseInput">
            {{ $t('memo.placeholder.insert_memo') }}
            <div class="collapse-button">
              <i v-if="inputCollapsed" class="fa fa-angle-down" />
              <i v-else class="fa fa-angle-up" />
            </div>
          </div>
          <div v-if="!inputCollapsed" class="input-control-area">
            <input-control
              v-if="options.useTitle"
              v-model="newMemo.title"
              :required="true"
              name="title"
              type="text"
              :no-title="true"
              :placeholder="$t('column.nm.title')"
              :title="$t('column.nm.title')"
            />
            <input-control
              v-model="newMemo.cn"
              :required="true"
              name="cn"
              type="html_editor"
              :editor-options="editorOptions"
              :no-title="true"
              :placeholder="$t('column.nm.cn')"
              :title="$t('column.nm.cn')"
            />
            <input-control
              v-if="options.usePriority"
              v-model="newMemo.priortCode"
              :required="true"
              name="priort_code"
              :options="priorityOptions"
              type="select"
              :no-title="true"
              :placeholder="$t('column.nm.priort_code')"
              :title="$t('column.nm.priort_code')"
            />
            <input-control
              v-if="options.sttusCodeGroup"
              v-model="newMemo.sttusCode"
              :required="true"
              name="sttus_code"
              type="select"
              :no-title="true"
              :options="statusOptions"
              :placeholder="$t('column.nm.sttus_code')"
              :title="$t('column.nm.sttus_code')"
            />
            <input-control
              v-if="options.useCharger"
              v-model="newMemo.chargerId"
              type="multiselect"
              name="charger_id"
              :no-title="true"
              :multiple="false"
              async-search-url="/user/search"
              :placeholder="$t('memo.text.charger')"
              :title="$t('memo.text.charger')"
            />
            <div v-if="options.useAttachment" class="file-attachment-control">
              <div class="file-attachment-summary clickable" @click="toggleCollapseFileAttachment()">
                <span>{{ $t('memo.button.attach_file') }}</span>
                <div class="collapse-button">
                  <i v-if="fileAttachmentCollapsed" class="fa fa-angle-down" />
                  <i v-else class="fa fa-angle-up" />
                </div>
              </div>
              <input-control
                v-if="!fileAttachmentCollapsed"
                v-model="newMemo.attachments"
                name="attachments"
                type="multifile"
                table-name="memo"
                :file-info="{'purpose': 'file_purpose.general'}"
                :no-title="true"
                :placeholder="$t('column.nm.attachment')"
                :title="$t('column.nm.attachment')"
              />
            </div>
            <div class="insert-button-area">
              <button class="form-control btn btn-primary" @click="addMemo()">
                {{ $t('common.button.insert') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    floating: {
      type: Boolean,
      default: false
    },
    tableName: {
      type: String,
      default: ''
    },
    columnName: {
      type: String,
      default: ''
    },
    tableKey: {
      type: [Number, String, Object],
      default: undefined
    },
    useComment: {
      type: Boolean,
      default: undefined
    },
    useCharger: {
      type: Boolean,
      default: undefined
    },
    useTitle: {
      type: Boolean,
      default: undefined
    },
    useAttachment: {
      type: Boolean,
      default: undefined
    },
    usePriority: {
      type: Boolean,
      default: undefined
    },
    forTable: {
      type: Boolean,
      default: undefined
    },
    type: {
      type: String,
      default: 'normal'
    },
    sttusCodeGroup: {
      type: String,
      default: undefined
    },
    /* 위 옵션들을 한 번에 객체로 전달 */
    memoOptions: {
      type: Object,
      default: () => {
        return undefined
      }
    },
    time: {
      type: Number,
      default: undefined
    },
    collapse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editorOptions: {
        theme: 'snow',
        modules: {
          toolbar: false
        }
      },
      memos: [],
      emergencyMemos: [],
      options: {},
      collapsed: false,
      isBusy: false,
      newMemo: {},
      fileAttachmentCollapsed: true,
      loadedSize: 0,
      totalSize: undefined,
      totalEmergencySize: undefined,
      includeEndedMemo: false,
      inputCollapsed: true,
      priorityCodes: undefined,
      statusCodes: undefined,
      priorityOptions: [],
      statusOptions: [],
      priorityOptionsWithoutEmptyValue: [],
      statusOptionsWithoutEmptyValue: []
    }
  },
  created() {
    if (this.memoOptions) {
      this.options = this.memoOptions
    }
    if (this.useComment !== undefined) {
      this.options.useComment = this.useComment
    }
    if (this.useCharger !== undefined) {
      this.options.useCharger = this.useCharger
    }
    if (this.useTitle !== undefined) {
      this.options.useTitle = this.useTitle
    }
    if (this.useAttachment !== undefined) {
      this.options.useAttachment = this.useAttachment
    }
    if (this.usePriority !== undefined) {
      this.options.usePriority = this.usePriority
    }
    if (this.forTable !== undefined) {
      this.options.forTable = this.forTable
    }
    if (this.type !== undefined) {
      this.options.type = this.type
    }
    if (this.sttusCodeGroup !== undefined) {
      this.options.sttusCodeGroup = this.sttusCodeGroup
    }
    this.collapsed = this.collapse
    this.load()
  },
  methods: {
    toggleCollapseInput() {
      this.inputCollapsed = !this.inputCollapsed
    },
    clickIncludeEndedMemo(e) {
      if (e) {
        e.stopPropagation()
        e.preventDefault()
      }
      this.$nextTick(() => {
        this.includeEndedMemo = $(e.target).prop('checked')
        this.load()
      })
    },
    async addMemo() {
      if (
        !(await this.validateUnder(
          $(this.$el)
            .find('.insert-memo-control')
            .get(0),
          '.app-body'
        ))
      ) {
        return
      }
      let url = '/memo/memo'
      if (this.tableName) {
        if (url.indexOf('?') >= 0) {
          url += '&'
        } else {
          url += '?'
        }
        url += 'tableName=' + this.tableName
      }
      if (this.columnName) {
        if (url.indexOf('?') >= 0) {
          url += '&'
        } else {
          url += '?'
        }
        url += 'columnName=' + this.columnName
      }
      if (this.tableKey) {
        if (url.indexOf('?') >= 0) {
          url += '&'
        } else {
          url += '?'
        }
        url += 'tableKey=' + this.tableKey
      }
      const params = JSON.parse(JSON.stringify(this.newMemo))
      if (params.chargerId) {
        params.chargerId = params.chargerId.value
      }
      this.$axios.$post(url, params).then(response => {
        if (response.resultCode === 'success') {
          this.newMemo = {}
          this.lastId = undefined
          this.load()
          this.inputCollapsed = true
        } else {
          console.error(this.$t(response.message, response.params))
          this.$toast.error(this.$t(response.message, response.params))
        }
      })
    },
    getOptions(colName, withoutEmptyValue) {
      const ret = []
      if (!withoutEmptyValue) {
        ret.push({
          text:
            (colName === 'priorityCodes'
              ? this.$t('column.nm.priort_code')
              : this.$t('column.nm.sttus_code')) +
            ' - ' +
            this.$t('common.placeholder.select'),
          value: ''
        })
      }
      if (this[colName]) {
        for (let i = 0; i < this[colName].length; i++) {
          ret.push({
            text: this.$t('code.nm.' + this[colName][i].codeId),
            value: this[colName][i].codeId
          })
        }
      }
      return ret
    },
    onDeleted(row) {
      if (this.memos && this.memos.length > 0) {
        for (let i = 0; i < this.memos.length; i++) {
          if (this.memos[i].id === row.id) {
            this.memos.splice(i, 1)
            break
          }
        }
      }
      if (this.emergencyMemos && this.emergencyMemos.length > 0) {
        for (let i = 0; i < this.emergencyMemos.length; i++) {
          if (this.emergencyMemos[i].id === row.id) {
            this.emergencyMemos.splice(i, 1)
            break
          }
        }
      }
      this.$forceUpdate()
    },
    onUpdated(row) {
      if (this.memos && this.memos.length > 0) {
        for (let i = 0; i < this.memos.length; i++) {
          if (this.memos[i].id === row.id) {
            this.memos[i] = row
            let codeAttr1
            for (let j = 0; j < this.statusCodes.length; j++) {
              if (this.statusCodes[j].codeId === row.sttusCode) {
                codeAttr1 = this.statusCodes[j].codeAttr1
              }
            }
            if (!this.includeEndedMemo && codeAttr1 !== 'in_progress') {
              this.memos.splice(i, 1)
            }
            break
          }
        }
      }
      if (this.emergencyMemos && this.emergencyMemos.length > 0) {
        for (let i = 0; i < this.emergencyMemos.length; i++) {
          if (this.emergencyMemos[i].id === row.id) {
            this.emergencyMemos[i] = row
            let codeAttr1
            for (let j = 0; j < this.statusCodes.length; j++) {
              if (this.statusCodes[j].codeId === row.sttusCode) {
                codeAttr1 = this.statusCodes[j].codeAttr1
              }
            }
            if (!this.includeEndedMemo && codeAttr1 !== 'in_progress') {
              this.emergencyMemos.splice(i, 1)
            }
            break
          }
        }
      }
      this.loadSummary()
    },
    load(append) {
      if (!append) {
        this.loadedSize = 0
      }
      this.isBusy = true
      let url = '/memo/memo'

      if (!this.options.sttusCodeGroup) {
        url += '?includeEndedMemo=true'
      } else {
        url += '?includeEndedMemo=' + this.includeEndedMemo
      }
      if (this.tableName) {
        url += '&tableName=' + this.tableName
      }
      if (this.columnName) {
        url += '&columnName=' + this.columnName
      }
      if (this.tableKey) {
        url += '&tableKey=' + this.tableKey
      }
      if (append && this.lastId) {
        url += '&lastId=' + this.lastId
      }
      if (this.options.sttusCodeGroup) {
        url += '&sttusCodeGroup=' + this.options.sttusCodeGroup
      }
      if (!this.statusCodes) {
        url += '&loadStatus=true'
      }
      if (this.options.usePriority && !this.priorityCodes) {
        url += '&priortCodeGroup=memo_priority'
      }
      this.$axios
        .$get(url, { no_loading: true })
        .then(response => {
          this.isBusy = false
          if (response.resultCode === 'success') {
            if (!append) {
              this.memos = []
            }
            this.$nextTick(() => {
              if (append) {
                this.memos = this.memos.concat(response.data.list)
              } else {
                this.memos = response.data.list
              }
              this.loadedSize += this.memos.length
              this.emergencyMemos = response.data.emergencyList
              if (response.data.priorityCodes) {
                this.priorityCodes = response.data.priorityCodes
                this.priorityOptions = this.getOptions('priorityCodes')
                this.priorityOptionsWithoutEmptyValue = this.getOptions(
                  'priorityCodes',
                  true
                )
              }
              if (response.data.statusCodes) {
                this.statusCodes = response.data.statusCodes
                this.statusOptions = this.getOptions('statusCodes')
                this.statusOptionsWithoutEmptyValue = this.getOptions(
                  'statusCodes',
                  true
                )
              }
              this.totalSize = response.data.totalSize
              this.totalEmergencySize = response.data.totalEmergencySize
              if (this.memos && this.memos.length > 0) {
                this.lastId = this.memos[this.memos.length - 1].id
              }
              this.$forceUpdate()
            })
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
        .catch(() => {
          this.isBusy = false
        })
    },
    loadSummary() {
      let url = '/memo/memoSummary'

      if (!this.options.sttusCodeGroup) {
        url += '?includeEndedMemo=true'
      } else {
        url += '?includeEndedMemo=' + this.includeEndedMemo
      }
      if (this.tableName) {
        url += '&tableName=' + this.tableName
      }
      if (this.columnName) {
        url += '&columnName=' + this.columnName
      }
      if (this.tableKey) {
        url += '&tableKey=' + this.tableKey
      }
      if (this.options.sttusCodeGroup) {
        url += '&sttusCodeGroup=' + this.options.sttusCodeGroup
      }
      this.$axios
        .$get(url, { no_loading: true })
        .then(response => {
          this.isBusy = false
          if (response.resultCode === 'success') {
            this.totalSize = response.data.totalSize
            this.totalEmergencySize = response.data.totalEmergencySize
            this.$forceUpdate()
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
        .catch(() => {
          this.isBusy = false
        })
    },
    toggleCollapseFileAttachment() {
      this.fileAttachmentCollapsed = !this.fileAttachmentCollapsed
    },
    toggleCollapse() {
      this.collapsed = !this.collapsed
    },
    getMemoCount(includePriorities) {
      if (!this.memos || this.memos.length === 0) {
        return 0
      }
      let cnt = 0
      for (let i = 0; i < this.memos.length; i++) {
        if (
          !includePriorities ||
          includePriorities.indexOf(this.memos[i].priort_code) >= 0
        ) {
          cnt++
        }
      }
      return cnt
    }
  }
}
</script>

<style scoped>
.emergency-memo {
  color: #ff0000;
  margin-right: 10px;
}
.input-control-area {
  margin-top: 10px;
}
.insert-memo-control-title {
  text-align: left;
}
.memo-list-container {
  border: 1px solid #cccccc;
  background-color: white;
  padding: 10px;
  width: 100%;
}
.insert-button-area {
  margin-top: 20px;
}
.memo-list-container.floating {
  width: auto;
  min-width: 400px;
  max-width: calc(100% - 300px);
  margin-bottom: 0;
  z-index: 11;
  -webkit-box-shadow: 5px 5px 7px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 5px 5px 7px rgba(0, 0, 0, 0.3);
  box-shadow: 5px 5px 7px rgba(0, 0, 0, 0.3);
}
.memo-list {
  border: 1px solid #cccccc;
  padding: 10px;
  margin-bottom: 10px;
  margin-top: 10px;
}
.collapse-button {
  float: right;
}
.memo-control {
  margin-bottom: 40px;
}
.memo-summary {
  padding: 5px 0;
}
.floating-memo-control .memo-summary {
  padding: 0;
}
.floating-memo-control.memo-control {
  margin-bottom: 0;
}
.no-memo {
  text-align: center;
  padding: 40px 0;
}
.file-attachment-summary {
  text-align: left;
  padding-bottom: 5px;
}
.insert-memo-control {
  text-align: left;
  padding: 10px;
  border: 1px solid #cccccc;
}
>>> .input-control {
  margin-bottom: 5px;
}
.close-button-area:hover {
  opacity: 0.5;
}
.close-button-area {
  position: absolute;
  right: 0;
  top: 0;
  padding: 10px;
  cursor: pointer;
}
.memo-include-ended-checkbox-area {
  text-align: left;
}
.memo-container-title {
  text-align: left;
}
.floating {
  position: absolute;
}
</style>
